import { NewsState } from "./reducer"

export const getAllNews = (state: { news: NewsState }) => state.news
